import { useCallback, useMemo, useState } from "react";
import { API_CONNECTED_OBJECT, API_USER, BASE_API } from "../constants/api";
import useRequest from "./useRequest";
import { OwnConnectedObjectType } from "../types/connected-object";
import { OrderType } from "../types/pagination";


type SimpleCOResponseType = {
  userConnectedObjetcs: OwnConnectedObjectType[]
}

const useOwnObjects = () => {
  const {
    error,
    isLoading,
    response,
    request
  } = useRequest<SimpleCOResponseType>();

  const [currentSort, setCurrentSort] = useState<null | {target: string; value: OrderType}>(null);
  const sortedObject = useMemo(() => {
    const data = response?.userConnectedObjetcs;
    if (!data) return null;
    if (!currentSort || currentSort.value === 'none') return data;
    
    const sortOrder = currentSort.value === 'DESC' ? -1 : 1;
    return [...data].sort((a, b) => {
      if (currentSort.target === 'url') {
        return a.url.localeCompare(b.url) * sortOrder;
      }
      if (currentSort.target === 'feat') {
        const featA = a.feature.type ?? '';
        const featB = b.feature.type ?? '';
        return featA.localeCompare(featB) * sortOrder;
      }
      return 0;
    })
  }, [response?.userConnectedObjetcs, currentSort]);

  
  const handleSort = useCallback((target: string, value: OrderType) => {
    setCurrentSort({target, value});
  }, [])

  const fetchOwnObjects = useCallback(() => {
    request(BASE_API, `${API_USER}/${API_CONNECTED_OBJECT}`, {secure: true});
  }, [request])

  return {isLoading, error, currentSortTarget: currentSort?.target, sortedObject, fetchOwnObjects, handleSort}
}

export default useOwnObjects;